module.exports = __webpack_public_path__ + "img/202310_01.5b625160.jpg";